import axios from 'axios';
import _get from 'lodash/get';
import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import { trackPage } from '../../lib/analytics-helper';
import { getRACEligibility } from './action-rac';
import Page from '../../lib/page';

import {
  REQUEST_CALLUS, RECEIVE_CALLUS_RESPONSE, RECEIVE_CALLUS_ERROR, BACK_TO_CONTACT_HOME, LOGOUT_TO_LOGIN, STORE_CHATBOT_QUERY_PARAMS,
} from '../constants/ActionTypes';
import { elmoExperimentResourceNames } from '../../lib/experiments-helper';
import { validateAMFlag } from '../../lib/globalHelper';
import { resetCallUsFromComplaintsPage } from './action-login-modal';

// Fetch Phone number
export function requestCallUs() {
  return {
    type: REQUEST_CALLUS,
    payload: undefined,
  };
}
export function receiveCallUsError() {
  return {
    type: RECEIVE_CALLUS_ERROR,
    payload: undefined,
  };
}

export function receiveCallUsResponse(response) {
  return {
    type: RECEIVE_CALLUS_RESPONSE,
    callUsData: response,
    callUsElmoTreatments: ((response.elmoTreatments) || []),
  };
}

function getTopicRefId(state) {
  if (state.modal && state.modal.fromChannel) {
    // logged out to logged in scenario
    return _get(state, 'smcResultKeeper.topicTreeSelectResult.topicRefId');
  }

  // Take topicRefId from persisted step up only when redirected from anw to callus page.
  if (state.persistedStepUp && typeof state.persistedStepUp.anw === 'object'
    && state.persistedStepUp.anw.isRedirectedToAnw && state.persistedStepUp.topic) {
    return _get(state, 'persistedStepUp.topic.topicRefId');
  }

  // log-out & log-in scenario
  return _get(state, 'selectResult.topicTreeSelectResult.topicRefId');
}

function isLoggedOutToLogin(state) {
  return {
    type: LOGOUT_TO_LOGIN,
    payload: !_isEmpty((state.modal || {}).fromChannel),
  };
}

function storeChatBotQueryParams(params) {
  return {
    type: STORE_CHATBOT_QUERY_PARAMS,
    payload: params,
  };
}

function isFinalIntent(isLoggedIn, state) {
  if (isLoggedIn && state.smcResultKeeper) {
    // during logout to login from final intent checking for topicTreeSelectResult existance
    return !_isEmpty(state.smcResultKeeper.topicTreeSelectResult);
  }
  return !_isEmpty(state.selectResult.topicTreeSelectResult);
}

export function fetchPhoneNumber(chatbotParams = {}) {
  return (dispatch, getState) => {
    // reseting complaints page flag after landing on callus page
    dispatch(resetCallUsFromComplaintsPage());
    const contactChannels = (getState().contactChannels || {}).OriginalRiskResponse;
    // Request A Call feature - On Login FireEligibility
    if (Page.isLoggedIn() && (Page.isRacAvaibleInChannelDecsions() || (contactChannels && Page.isRacAvaibleInContactChannels(contactChannels)))) {
      dispatch(getRACEligibility());
    }

    // Adding Callus ELMO ResourceName as query param
    let URL = `/smarthelp/phone-info?resourceName=${elmoExperimentResourceNames.newCallusDesign}`;
    if (!_isEmpty(chatbotParams) && chatbotParams.topic_key && chatbotParams.topic_code && chatbotParams.chatbot) {
      const topicCode = chatbotParams.topic_code;
      const topicKey = chatbotParams.topic_key;
      URL = `${URL}?topicRefId=${topicCode}&sacCustomKey=${topicKey}`;
      dispatch(storeChatBotQueryParams(chatbotParams));
    } else {
      const formFields = _get(getState(), 'persistEmailForm.fields');
      const isLogOutToLogin = !_isEmpty((getState().modal || {}).fromChannel);

      const finalIntent = isFinalIntent(isLogOutToLogin, getState());

      // checking for customphone option in form fields
      const customPhoneIndex = _findIndex(formFields, { type: 'customphone' });
      const phoneDetails = formFields && formFields[customPhoneIndex] && formFields[customPhoneIndex].label;

      // custom option key from SAC
      const sacCustomKey = phoneDetails && phoneDetails[0] && phoneDetails[0].phone_type;

      const topicRefId = getTopicRefId(getState());
      // if topic refId exists then append to API
      if (topicRefId) {
        URL = `${URL}&topicRefId=${topicRefId}`;
      }

      // if SAC custom option key exists append to URL
      if (finalIntent && sacCustomKey) {
        URL = `${URL}&sacCustomKey=${sacCustomKey}`;
      }
    }
    dispatch(isLoggedOutToLogin(getState()));
    dispatch(requestCallUs());
    return axios.get(URL)
      .then((response) => {
        // Send FPTI impression event for login webpin for idi markets
        // for non idi markets sending the impression in callus container due to AM flag validation to display callus channel
        if (!validateAMFlag()) {
          if (_get(response, 'data.contactInfo.web_pin')) {
            trackPage({ id: 'webPinSuccess', link: 'smarthelp-call-us|webpin_displayed' });
          } else if (_get(response, 'data.contactInfo.isphonePresent')) {
            trackPage({ id: 'webPinNotApplicable', link: 'smarthelp-call-us|webpin_not_applicable' });
          } else {
            trackPage({ id: 'webPinfailure', link: 'smarthelp-call-us|webpin_not_displayed' });
          }
        }
        dispatch(receiveCallUsResponse(response.data));
      })
      .catch(() => dispatch(receiveCallUsError()));
  };
}

export function backToHome() {
  return {
    type: BACK_TO_CONTACT_HOME,
  };
}
